import { render, staticRenderFns } from "./personal_notes.vue?vue&type=template&id=0e4de3ae&scoped=true&"
import script from "./personal_notes.vue?vue&type=script&lang=js&"
export * from "./personal_notes.vue?vue&type=script&lang=js&"
import style0 from "./personal_notes.vue?vue&type=style&index=0&id=0e4de3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4de3ae",
  null
  
)

export default component.exports